import {observer} from 'mobx-react-lite'
import React, {useRef} from 'react'
import ReactPerfectScrollbar from 'react-perfect-scrollbar'
import tw from 'tailwind-styled-components'
import useResizeObserver from 'use-resize-observer'
import {WithPerfectScrollbar} from '@components/common/with-scrollbar/with-scrollbar'
import {useTimelineNewStore} from '@components/timeline-new/timeline-new-store'
import {Graph} from './graph'
import {Measure} from './measure'

const TwDiagram = tw(WithPerfectScrollbar)`
  min-w-0
  flex
  flex-col
  shadow-line-base
  overflow-hidden
`

const TwDiagramContainer = tw.div`
  relative
  isolate
  flex-1
  flex
  flex-col
  min-h-0
  min-w-0
`

const TwMeasure = tw(Measure)`
  flex-none
`

const TwGraph = tw(Graph)`
  flex-1
`

export interface DiagramProps {
  className?: string
}

export const Diagram = observer((props: DiagramProps) => {
  const {className} = props
  const [state, store] = useTimelineNewStore()

  const psbRef = useRef<ReactPerfectScrollbar>()
  useResizeObserver({
    ref: state.diagramEl,
    onResize: () => {
      psbRef.current?.updateScroll()
      store.scheduleRecalc()
    }
  })

  return (
    <TwDiagram
      ref={psbRef}
      containerRef={store.setDiagramEl}
      className={className}
      scrollDirection="x"
      onScroll={store.graphHelper.graphScrollX}
      onMouseDown={store.graphHelper.startGraphDrag}
      drag={false}
    >
      <TwDiagramContainer ref={store.setDiagramContainerEl}>
        <TwMeasure />
        <TwGraph />
      </TwDiagramContainer>
    </TwDiagram>
  )
})
